export * from './IconLeaf';
export { default as IconLeaf } from './IconLeaf';
